import script from "./UTooltipInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./UTooltipInfo.vue?vue&type=script&setup=true&lang=js"

import "./UTooltipInfo.vue?vue&type=style&index=0&id=6c0ea011&lang=scss"

const __exports__ = script;

export default __exports__